import { colors } from '../colors'

export const Heading = {
  baseStyle: {
    color: colors.gray[700],
    fontFamily: 'heading',
    fontStyle: 'normal'
  }
}
